/**
 * Tipos de erro (failure) retornados pela aplicação.
 * Use Failure em use cases e na UI em vez de exceções.
 */

export interface Failure {
  readonly code: string;
  readonly message: string;
  readonly cause?: unknown;
}

export function failure(code: string, message: string, cause?: unknown): Failure {
  return { code, message, cause };
}
